<template>
  <div class="job-list-item">
    <div class="job-list-item__title" :class="{loader: loader}">
      {{job.title}}
    </div>
    <div class="job-list-item__desc">
      <html-block
        class="job-list-item__desc-text"
        :class="{loader: loader}"
        :content="job.prev_text"
      />
    </div>
    <div class="job-list-item__req">
      <job-item-requirements
        v-if="job.city"
        img_icon_name="location"
        :loading="loader">
        {{job.city.title}}
      </job-item-requirements>
      <job-item-requirements
        v-if="job.contract"
        img_icon_name="work"
        :loading="loader">
        {{job.contract.title}}
      </job-item-requirements>
      <job-item-requirements
        v-if="job.languages && job.languages.length"
        img_icon_name="language"
        slot_tag="div"
        :loading="loader">
        <span v-for="(language, index) in job.languages" :key="language.id">
          <template v-if="index"> / </template>
          {{ language.title }}
          <template v-if="language.additional_info"> - {{language.additional_info}}</template>
        </span>
      </job-item-requirements>
    </div>
    <div
      class="job-list-item__subscribe">
      <template v-if="loader">
        <div class="loader"></div>
      </template>
      <template v-else>
        <arrow-text-hover
          class="job-list-item__subscribe-link"
          component_tag="a"
          :href="job.link"
          :text="$t('btn.apply_to_job')"/>
        <div
          class="job-list-item__subscribe-dots">
          <img src="/images/icons/dots.svg" alt="work">
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import ArrowTextHover from "../../small_parts/ArrowTextHover.vue";
import JobItemRequirements from "./JobItemRequirements.vue";
import HtmlBlock from "../../small_parts/HtmlBlock.vue";

export default {
  name: 'JobListItem',
  components: {HtmlBlock, JobItemRequirements, ArrowTextHover},
  props: {
    job: {
      type: Object,
      default: () => {},
      required: true
    },
    loader: {
      type: Boolean,
      default: false,
    },
  }
}
</script>
